const basePath = resourceId => `passenger/tnes/${resourceId}`

export default {
  /*
   * index() lista las TNEs
   */
  async index(params) {
    return Vue.http.get(basePath(''), {params}).then(response => response.data)
  },
  /**
   * create() crea una TNE
   * */
  async create(data) {
    return Vue.http.post(basePath(''), {data}).then(response => response.data.data)
  },
  /**
   * update() actualiza una TNE
   * */
  async update(id, data) {
    return Vue.http.put(basePath(id), {data}).then(response => response.data.data)
  },
  /**
   * deregister() da de baja una TNE registrada
   * */
  async deregister(id) {
    const path = `${basePath(id)}/deregister`

    const response = await Vue.http.put(path)
    return response.data.data
  }
}
